import { extendTheme } from "@chakra-ui/react";

export const lightTheme = extendTheme({
    color:{
      text:{
        primary: "#FFFFFF",
        secondary: "#003F88",
        tertiary: "#00AEEF",
        quaternary: 'rgba(120,120,120)'
      }
    },
    background:{
      primary: "#00AEEF",
      secondary: "#003F88",
      tertiary: "#17D8AB",
      quaternary: "#FFFFFF",
      purple: "purple"
    }
});
